import { Injectable } from '@angular/core';

export interface AppConfig {
  URL_WEB: string;
  production?: boolean;
  apiUrl?: string,
  filesUrl?: string,
  MODE?: string
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  
  static config: AppConfig;

  static load(): Promise<void> {
    return fetch('/assets/config/config.json')
      .then(r => r.json())
      .then(c => AppConfigService.config = c);
  }



  /**
  private config!: AppConfig;


   * Se ejecuta desde APP_INITIALIZER
   * Angular espera a que esta Promise termine
   
  load(): Promise<void> {
    return fetch('/assets/config/config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('No se pudo cargar config.json');
        }
        return response.json();
      })
      .then((data: AppConfig) => {
        this.config = data;
      });
  }

  get apiUrl(): string {
    return this.config.apiUrl;
  }
  get afipUrl(): string | undefined {
    return this.config.apiUrlAfip;
  }
  get mailUrl(): string | undefined {
    return this.config.apiUrlEmail;
  }
  get isproduccion(): boolean | undefined {
    return this.config.production;
  }
  get filesUrl(): string | undefined {
    return this.config.urlFiles;
  }
  get logodefaultUrl(): string | undefined {
    return this.config.URL_LOGO_DEFAULT;
  }
  get agentai(): boolean | undefined {
    return this.config.production;
  }
  get documentai(): boolean | undefined {
    return this.config.production;
  }

*/
}
